import { number, object } from 'zod';

import { FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT } from '@occc-app/lib/constants/validationMessages';

// Offer Fulfillment Priority (OCST-28864): optional, positive whole number
// bounded to 1000. Kept as its own schema, separate from name/description, so it
// can be composed into each campaign-component configuration schema independently.
export const FULFILLMENT_PRIORITY_MAX = 1000;

export const OfferFulfillmentPrioritySchema = object({
  fulfillmentPriorityLevel: number()
    .int()
    .positive(FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT)
    .max(FULFILLMENT_PRIORITY_MAX, FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT)
    .optional(),
});
